import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { bannerColour } from './banner-constants';
import { materialSymbols, MaterialSymbolValue } from '../../../shared/constants/material-symbols';


@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
    standalone: false
})
export class BannerComponent implements OnInit, OnChanges {

  materialSymbols = materialSymbols;
  @Input() id: string = 'banner';
  @Input() colour: bannerColour = bannerColour.blue;
  @Input() bannerIcon: MaterialSymbolValue | null = null;
  @Input() message: string | null = null;
  isVisible: boolean = true;

  ngOnInit() : void {
    this.setIsVisible();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] && !changes['message'].firstChange) {
      this.message = changes['message'].currentValue;
      this.setIsVisible();
    }
  }

  setIsVisible() : void {
    this.isVisible = this.message !== null && this.message !== '';
  }

  closeBanner() : void {
    this.isVisible = false;
  }

}


